import { InjectionToken } from '@angular/core';

import {
	type EnvironmentRepository,
	HttpConfig,
	type HttpInterceptor,
	type HttpService,
	type StorageRepository,
	type WebAuthnClientRepository
} from '@contexts/shared/domain';

export const STORAGE_REPOSITORY = new InjectionToken<StorageRepository>('StorageRepository');
export const GLOBAL_HTTP_CONFIG = new InjectionToken<HttpConfig>('GlobalHttpConfig');
export const HTTP_INTERCEPTOR = new InjectionToken<HttpInterceptor>('HttpInterceptor');
export const HTTP_SERVICE = new InjectionToken<HttpService>('HttpService');
export const WINDOW = new InjectionToken<Window>('Global window object', {
	factory: () => window
});
export const ENVIRONMENT_REPOSITORY = new InjectionToken<EnvironmentRepository>(
	'EnvironmentRepository'
);

export const WEB_AUTHN_CLIENT_REPOSITORY = new InjectionToken<WebAuthnClientRepository>(
	'WebAuthnClientRepository'
);
